import React, { FC, useState } from 'react';
import { Grid, Typography, Switch, FormControlLabel } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { CustomSVG, PaddedPaper } from 'components';
import { makeStyles } from '@material-ui/core/styles';

interface IProps {
  setShareSocialNetwork: (val: boolean) => void;
}

const useStyles = makeStyles(theme => ({
  paper: {
    width: '100%',
    paddingBottom: theme.spacing(2.5),
  },
}));

const SocialNetwork: FC<IProps> = ({ setShareSocialNetwork }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [isChecked, setIsChecked] = useState(false);

  function onChangeSwitch() {
    setIsChecked(!isChecked);
    setShareSocialNetwork(!isChecked);
  }

  return (
    <PaddedPaper square className={classes.paper}>
      <Grid container alignItems="flex-start" wrap="nowrap">
        <Grid item xs={1}>
          <CustomSVG name="share" color={isChecked ? 'inherit' : 'disabled'} />
        </Grid>
        <Grid item container direction="column" xs={10}>
          <Grid item>
            <Typography variant="subtitle1">{t('posting:shareSocialNetwork')}</Typography>
          </Grid>
          <Grid item>
            <Typography color="textSecondary">{t('posting:guidelineNetwork')}</Typography>
          </Grid>
        </Grid>
        <Grid item xs={1}>
          <FormControlLabel
            control={<Switch checked={isChecked} onChange={onChangeSwitch} color="primary" />}
            label={null}
            labelPlacement="bottom"
          />
        </Grid>
      </Grid>
    </PaddedPaper>
  );
};

export default SocialNetwork;
